;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputCheckboxList', inputCheckboxList)

  /* @ngInject */
  function inputCheckboxList () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        description: '@',
        modelPropertyName: '@',
        model: '=',
        value: '<',
        disabled: '<',
        mandatory: '<',
        change: '=',
        options: '<',
        enableHideUnchecked: '<'
      },
      templateUrl: '/core/directives/input-checkbox-list/input-checkbox-list-directive.html?$$REVISION$$',
      controller: 'InputCheckboxListController'
    }
  }
})()
